// Definição para o modal de busca de Categorias Financeiras
// Factory function - recebe todos os filtros como parâmetros, sem magic strings
// Os valores das constants (CATFIN_TP_MOV, ST) são injetados pelo componente
//
// ⚠️  ATENÇÃO — Parâmetro idPlanoCategoriaFinanceira (6º parâmetro)
// ================================================================
// A API de CategoriasFinanceiras EXIGE o idPlanoCategoriaFinanceira como
// filtro obrigatório. Se passado null ou omitido, a busca no modal retornará
// vazio (sem resultados).
//
// O componente chamador DEVE resolver o plano de categoria financeira vigente
// antes de chamar esta factory. Exemplo de implementação:
//
//   import { FIN_ST_PLAN_CATEGFIN } from '@/constants/FIN_ST_PLAN_CATEGFIN'
//   import api from '@/services/api'
//
//   const idPlanoCategoriaFinanceira = ref(null)
//
//   const resolverPlanoCategoria = async () => {
//     const res = await api.get('/PlanosCategoriasFinanceiras', {
//       params: {
//         lstStatusPlano: FIN_ST_PLAN_CATEGFIN.Ativo,
//         idEmpresa: authStore.empresaAtiva,
//         pageSize: 50
//       }
//     })
//     const hoje = new Date()
//     const plano = (res.data || []).find(p => {
//       if (!p.dataInicioVigencia || !p.dataFimVigencia) return false
//       const inicio = new Date(p.dataInicioVigencia + 'T00:00:00')
//       const fim = new Date(p.dataFimVigencia + 'T00:00:00')
//       return hoje >= inicio && hoje <= fim
//     })
//     idPlanoCategoriaFinanceira.value = plano ? plano.idPlanoCategoriaFinanceira : null
//   }
//
// Consulte também: Docs CT Comex/Tecnologias e Especificações/_diretrizes_desenvolvimento/FRONTEND/11-search-definitions.md
// ================================================================

import { CATFIN_TP_MOV_CUSTOM } from '@/constants/CATFIN_TP_MOV.Custom'

export const criarConfigBuscaCategoriaFinanceira = (titulo, lstTipoMovimentacao, lstStatus, idOrganizacao, tipoTitulo = null, idPlanoCategoriaFinanceira = null, permiteLancamento = true) => {
  // Se tipoTitulo for informado (ex: FIN_TPTITULO.APagar), resolve automaticamente
  // o grupo de constantes via CATFIN_TP_MOV_CUSTOM, sem IFs no componente chamador
  const rawResult = tipoTitulo ? CATFIN_TP_MOV_CUSTOM.porTipoTitulo(tipoTitulo) : null
  const tipoMovimentacaoResolvido = tipoTitulo ? rawResult.join(',') : lstTipoMovimentacao

  const filtros = {
    lstTipoMovimentacao: tipoMovimentacaoResolvido,
    lstStatus,
    idOrganizacao,
    permiteLancamento,
    sortField: 'codigoEstruturado',
    sortOrder: 'asc'
  }

  // idPlanoCategoriaFinanceira é obrigatório pela API de CategoriasFinanceiras
  if (idPlanoCategoriaFinanceira) {
    filtros.idPlanoCategoriaFinanceira = idPlanoCategoriaFinanceira
  }

  return {
    label: 'Categoria Financeira',
    placeholder: 'Código...',
    titulo,
    endpointApi: 'CategoriasFinanceiras',
    endpointFetchPorCodigo: 'CategoriasFinanceiras/por-codigo',
    idField: 'idCategoriaFinanceira',
    displayField: 'codigoEstruturado',
    descField: 'nomeExibicao',
    camposFiltro: [
      { label: 'Nome', model: 'busca', tipo: 'text' }
    ],
    colunasGrid: [
      { header: 'Código + Nome', dataField: 'nomeExibicao', width: '70%' },
      { header: 'Tipo', dataField: 'lstTipoMovimentacaoTexto', width: '30%' }
    ],
    filtrosFixos: filtros
  }
}
